module.exports = __webpack_public_path__ + "static/10th-f4f8745e7b980c757c532dfcee826af8.jpg";